import React, { useEffect, useState } from "react";

import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import backdropStyle from "./backdrop.module.css";
import ThemeProvider from "@mui/material/styles/ThemeProvider";
import createTheme from "@mui/material/styles/createTheme";
import responsiveFontSizes from "@mui/material/styles/responsiveFontSizes";
// import Autocomplete from "@mui/material/Autocomplete";
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';

import { fullTeamArray } from "../Data/fullTeamArray";
import Grid from "@mui/material/Unstable_Grid2";
import Stack from "@mui/material/Stack";
import SearchIcon from "@mui/icons-material/Search";
import { ArrowForward } from "@mui/icons-material";

const date = new Date(Date.now());
let weekdayLong = date.toLocaleDateString("en-US", { weekday: "long" });
let dayNumber = date.toLocaleDateString("en-US", { day: "numeric" });
let monthLong = date.toLocaleDateString("en-US", { month: "long" });

let modalTheme = createTheme({
	palette: { mode: "dark" },
	components: {
		MuiDialog: {
			styleOverrides: {
				inputRoot: {
					color: "white",
				},
				paper: {
					backgroundColor: "transparent",
					// backdropFilter: 'blur(80px)',
					color: "white",
					borderRadius: "20px",
					// maxWidth: "50%"
				},
			},
		},
	},
	typography: {
		fontFamily: "Lexend, Arial",
	},
});

modalTheme = responsiveFontSizes(modalTheme);

let nameList = fullTeamArray.map((name) => name.name);

const headerStyle = {
	fontSize: "1rem",
	fontWeight: 600,
	color: "white",
	textTransform: "uppercase",
};

const filter = createFilterOptions();


export function UserSelection(props) {
	const [value, setValue] = useState(null);
	return (
		<>



			{/* <Autocomplete
  freeSolo
  options={nameList}
  value={value}
  onChange={(event, newValue) => {
    props.setNameValue(newValue);
    setValue(newValue);
  }}
  renderInput={(params) => (
    <TextField
      {...params}
      label="Name"
      placeholder="Type or select your name"
    />
  )}
  isOptionEqualToValue={(option, value) =>
    option.label === value.label
  }
  createText={(name) => `Add "${name}"`}
  noOptionsText="Add a new name"
/> */}
			
				<Autocomplete
					freeSolo
					fullWidth
					

					options={nameList.slice(1)}
					value={value}
					onChange={(event, newValue) => {
						props.setNameValue(newValue);
						setValue(newValue);
					}}

					filterOptions={(options, params) => {
						const filtered = filter(options, params);

						const { inputValue } = params;
						// Suggest the creation of a new value
						const isExisting = options.some((option) => inputValue === option.title);
						if (inputValue !== '' && !isExisting) {
							filtered.push({
								inputValue,
								label: `Add "${inputValue}"`,
							});
						}

						return filtered;
					}}

					color="blue"
					renderInput={(params) => (
						<TextField
							{...params}
							label="Name"
							fullWidth
							placeholder="Type or select your name"
						/>
					)}

				/>
				
			
		</>
	);
}

export function ZipCodeField({ setZipCode, disabled, error }) {
	const [value, setValue] = useState("");

	const handleChange = (event) => {
		setValue(event.target.value);
		setZipCode(event.target.value);
	};

	return (
		<>
			<TextField
				label="Zip Code"
				fullWidth
				required
				error={error}
				disabled={disabled}
				value={value}
				placeholder="Enter your zip code"
				onChange={handleChange}
				inputProps={{
					maxLength: 5,

				}}
			/>
		</>
	);
}

export default function FormDialog({
	setUserName,
	dialogForecastData,
	setDialogForecastData,
	ipTime,
	inputTime,
	onZipCodeSubmit,
	zipCode,
	setZipCode,
	// setInputName,
	showLookup,
	setShowLookup,
	dialogOpen,
	setDialogOpen,
	nameValue,
	setNameValue,
}) {
	useEffect(() => {
		sessionStorage.setItem("hasLoaded", true);
		if (!localStorage.getItem("userName")) {
			setDialogOpen(true);
		}
	}, [setDialogOpen]);

	const handleClose = () => {
		setDialogOpen(false);
	};

	const handleSubmit = () => {
		const userName = nameValue.split(" ")[0];
		setUserName(userName);
		localStorage.setItem("userName", userName);
		onZipCodeSubmit(zipCode);
		setDialogOpen(false);
		// setInputName("Daniel Dobrzensky");
		localStorage.setItem("fullName", nameValue);
	};

	const handleLookup = () => {
		localStorage.setItem("hasSubmitted", true);
		setShowLookup(true);
		onZipCodeSubmit(localStorage.setItem("zipCode", zipCode));
	};

	const handleReset = () => {
		setShowLookup(false);
		setZipCode("");
		localStorage.removeItem("zipCode");
		localStorage.removeItem("hasSubmitted");
		setNameValue("");
	};

	return (




		<ThemeProvider theme={modalTheme}>
			<Dialog
				sx={{
					"& .MuiDialog-paper": {
						background: `linear-gradient(127.09deg, rgba(6, 11, 40, 0.94) 19.41%, rgba(10, 14, 35, 0.49) 76.65%)`,
						width: "550px",
						maxWidth: "lg",
						flexDirection: "row",
						alignContent: "space-between",
						justifyContent: "space-around",
						alignItems: "stretch",
					},
				}}
				className={`${backdropStyle.backdrop}`}
				open={dialogOpen}
				onClose={handleClose}>
				<Grid
					rowSpacing={2}
					textAlign="center"
					alignItems="center"
					alignContent="space-between"
					justifyContent="center"
					container
					xs={12}>
					<Grid xs={12}>
						{!nameValue && (
							<>
								<DialogTitle mt={2} variant="h4">
									Hey there! 👋
								</DialogTitle>
							</>
						)}

						<DialogContent>
							{showLookup && (
								<>
									<Grid container flexDirection="column">
										<DialogTitle variant="h5">
											Does this look right?
										</DialogTitle>
										<Grid
											xs={12}
											display="flex"
											flexDirection="row"
											justifyContent="space-around"
											ml={1}>
											<Grid xs={6} display="flex" flexDirection="column">
												<DialogContentText style={headerStyle} mt={1}>
													Name
												</DialogContentText>
												<DialogContentText variant="subtitle1">
													{nameValue}
												</DialogContentText>
											</Grid>
											<Grid xs={6} display="flex" flexDirection="column">
												<DialogContentText style={headerStyle} mt={1}>
													Zipcode
												</DialogContentText>

												<DialogContentText variant="subtitle1">
													{localStorage.getItem("zipCode")}
												</DialogContentText>
											</Grid>
										</Grid>
										<Grid
											xs={12}
											display="flex"
											flexDirection="row"
											justifyContent="space-around"
											ml={1}>
											<Grid xs={6} display="flex" flexDirection="column">
												<DialogContentText style={headerStyle} mt={1}>
													Location
												</DialogContentText>
												<DialogContentText variant="subtitle1">
													{dialogForecastData.name}, {dialogForecastData.region}
												</DialogContentText>
											</Grid>
											<Grid xs={6} display="flex" flexDirection="column">
												<DialogContentText style={headerStyle} mt={1}>
													Timezone
												</DialogContentText>
												<DialogContentText variant="subtitle1">
													{dialogForecastData.tz_id}
												</DialogContentText>
											</Grid>
										</Grid>
										<Grid
											xs={12}
											display="flex"
											flexDirection="row"
											justifyContent="space-around"
											ml={1}>
											<Grid xs={6} display="flex" flexDirection="column">
												<DialogContentText style={headerStyle} mt={1}>
													Local Time
												</DialogContentText>
												<DialogContentText variant="subtitle1">
													{inputTime}
												</DialogContentText>
											</Grid>
											<Grid xs={6} display="flex" flexDirection="column">
												<DialogContentText style={headerStyle} mt={1}>
													Date
												</DialogContentText>
												<DialogContentText variant="subtitle1">
													{weekdayLong}&nbsp;
													{monthLong}&nbsp;
													{dayNumber}
												</DialogContentText>
											</Grid>
										</Grid>
									</Grid>
								</>
							)}

							{!nameValue && (
								<>
									<img
										height="225px"
										src="https://dano707.github.io/world-clock/welcome-screen.png"
										alt="welcome screen"
									/>
								</>
							)}
						</DialogContent>

						{!nameValue && (
							<>
								<DialogContentText px={6} mb={1} variant="h6" color="white">
									This app makes it easier to keep track of teams working across
									multiple timezones.
								</DialogContentText>
								<DialogContentText fontSize="1rem">
									First, enter your name in the field below.
								</DialogContentText>
							</>
						)}
						{!showLookup && nameValue && (
							<DialogContentText mx={3} variant="h6">
								Next, type in your zip and click "Lookup".
							</DialogContentText>
						)}

						<DialogContent>
							<Grid xs={12}>
								{!nameValue && <UserSelection setNameValue={setNameValue} />}

								{nameValue && !showLookup && (
									<Stack direction="row" spacing={2}>
										<ZipCodeField
											setZipCode={setZipCode}
											disabled={!nameValue}
										/>
										<Button
											disabled={zipCode?.length !== 5}
											variant="outlined"
											onClick={handleLookup}
											size="large"
											sx={{ width: "25%", fontSize: "12px" }}
											fullWidth
											startIcon={<SearchIcon />}>
											Lookup
										</Button>
									</Stack>
								)}
							</Grid>
						</DialogContent>
					</Grid>
					{showLookup && (
						<>
							<Grid xs={12}>
								<DialogContent>
									<DialogActions sx={{ justifyContent: "center" }}>
										<Button
											sx={{ color: "white", border: "1px solid white" }}
											fullWidth
											variant="outlined"
											onClick={handleReset}>
											Go back
										</Button>
										<Button
											fullWidth
											variant="contained"
											onClick={handleSubmit}>
											Looks good
										</Button>
									</DialogActions>
								</DialogContent>
							</Grid>
						</>
					)}
				</Grid>
			</Dialog>
		</ThemeProvider>

	);
}
